import '../scss/main.scss';

// Modules front — ajoutés au fil des composants :
// - navigation / méga-menu
// - modal générique + intégration Click2Buy
// - accordéons (FAQ)
// - accordéons produit (PDP)

document.documentElement.classList.add('js');
